import { isArray } from './array';
import { isBuffer } from './buffer';
import { isDate } from './date';
import { isMap } from './map';
import { isNil } from './maybe';
import { isNumber } from './number';
import { isObject } from './object';
import { isSet } from './set';
import { isString } from './string';

function isEmpty(value: unknown): boolean {
  if (isNil(value)) {
    return true;
  }

  if (isString(value)) {
    return value.trim().length === 0;
  }

  if (isArray(value) || isBuffer(value)) {
    return value.length === 0;
  }

  if (isNumber(value) || isDate(value)) {
    return false;
  }

  if (isMap(value) || isSet(value)) {
    return value.size === 0;
  }

  if (isObject(value)) {
    return Object.keys(value).length === 0;
  }

  return false;
}

export { isEmpty };
